import React from 'react';
import { styled } from '@linaria/react';

function PopCircle({ isPopped }: { isPopped: boolean }) {
  const id = React.useId();

  if (!isPopped) {
    return null;
  }

  return (
    <Svg viewBox="0 0 100 100" fill="none">
      <defs>
        <mask id={`${id}-pop-mask`}>
          <rect x="0" y="0" width="100" height="100" fill="white" />
          <MaskCircle cx="50" cy="50" r="0" fill="black" />
        </mask>
      </defs>

      <MainCircle
        mask={`url(#${id}-pop-mask)`}
        cx="50"
        cy="50"
        r="0"
        fill="hsl(270deg 100% 80%)"
      />
    </Svg>
  );
}

const GROW_DURATION = 550;
const MASK_DELAY = 130;
const TIME_UNTIL_POPPED = GROW_DURATION + MASK_DELAY;

const Svg = styled.svg`
  --easing-smooth: cubic-bezier(0.18, 0.95, 0.04, 0.98);
  position: absolute;
  inset: 0;
`;

const MaskCircle = styled.circle`
  @keyframes grow {
    to {
      r: 50;
    }
  }

  animation:
    grow ${GROW_DURATION}ms ${MASK_DELAY}ms var(--easing-smooth) both,
    fadeToTransparent 0ms ${TIME_UNTIL_POPPED}ms forwards;
`;

const MainCircle = styled.circle`
  --from-color: hsl(350deg 100% 60% / 0.5);

  @keyframes colorShift {
    from {
      fill: var(--from-color);
    }
  }
  @keyframes grow {
    to {
      r: 50;
    }
  }
  fill: hsl(270deg 100% 80%);
  animation:
    grow ${GROW_DURATION}ms var(--easing-smooth) forwards,
    colorShift ${GROW_DURATION}ms,
    fadeToTransparent 0ms ${TIME_UNTIL_POPPED}ms forwards;
`;

export default PopCircle;
